export const CONF_ENVIRONMENT = process.env.REACT_APP_NODE;
export const API_URL = process.env.REACT_APP_API_URL;
export const CLINIC_API_URL = process.env.REACT_APP_CLINIC_API_URL;
export const CONF_PATIENT_URL = process.env.REACT_APP_PATIENT_URL;
export const CONF_DOCTOR_URL = process.env.REACT_APP_DOCTOR_URL;
export const CONF_STRIPE_ID = process.env.REACT_APP_STRIPE_ID;